import { Badge } from "@/components/ui/badge";
import { StripeLink } from "@/components/StripeLink";
import { formatDate } from "@/lib/format";
import { disputeChip, gatewayName } from "@/lib/payments";
import { paidWith, type PaymentRow } from "./orders";

/** What paid, through which gateway, with "Open in Stripe" for Stripe payments. */
export function PaidWith({ p }: { p: PaymentRow }) {
  return (
    <span className="block">
      {paidWith(p)}
      {p.gateway && <span className="block text-[var(--color-muted-foreground)]">via {gatewayName(p.gateway)}</span>}
      {p.dashboard_url && (
        <span className="block">
          <StripeLink url={p.dashboard_url} what="This payment" />
        </span>
      )}
    </span>
  );
}

/** The chargeback chip on a payment (billing records Stripe's charge.dispute.* events). */
export function DisputeBadge({ p }: { p: Pick<PaymentRow, "dispute_status" | "dispute_reason" | "disputed_at"> }) {
  const chip = disputeChip(p.dispute_status);
  if (!chip) return null;
  const why = [p.dispute_reason?.replace(/_/g, " "), p.disputed_at ? `opened ${formatDate(p.disputed_at)}` : ""].filter(Boolean).join(", ");
  return (
    <Badge variant={chip.variant} title={`The customer's bank opened a chargeback${why ? ` (${why})` : ""}. Answer it in Stripe's dashboard before its deadline.`}>
      {chip.label}
    </Badge>
  );
}
